import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/empresa', label: 'Empresa' },
    { path: '/servicios', label: 'Servicios' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contacto', label: 'Contacto' },
  ];

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-dark-bg/95 backdrop-blur-lg shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://public.readdy.ai/ai/img_res/06424b75-440f-4c86-baff-26ebcba943a6.png"
              alt="PLADUREX - Instalación de Pladur en Sabadell"
              className="h-12 w-auto"
            />
            <span className="text-2xl font-display font-bold text-light-text">
              PLADUREX
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-orange'
                    : 'text-light-text hover:text-primary-orange'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-3">
            <a
              href="tel:+34629501941"
              className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-light-text hover:text-primary-orange transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-lg"></i>
              <span>629 501 941</span>
            </a>
            <a
              href="https://wa.me/34629501941"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 px-5 py-2.5 bg-primary-orange text-white rounded-lg font-medium text-sm hover:shadow-glow-orange transition-all whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span>WhatsApp</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-light-text p-2"
            aria-label="Menú"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="lg:hidden py-4 border-t border-dark-lighter"
          >
            <nav className="flex flex-col space-y-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`px-4 py-2 text-sm font-medium transition-colors ${
                    location.pathname === link.path
                      ? 'text-primary-orange'
                      : 'text-light-text hover:text-primary-orange'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <div className="flex flex-col space-y-2 px-4 pt-2">
                <a
                  href="tel:+34629501941"
                  className="flex items-center justify-center space-x-2 px-4 py-2.5 border border-primary-orange text-primary-orange rounded-lg font-medium text-sm whitespace-nowrap"
                >
                  <i className="ri-phone-line text-lg"></i>
                  <span>629 501 941</span>
                </a>
                <a
                  href="https://wa.me/34629501941"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center space-x-2 px-4 py-2.5 bg-primary-orange text-white rounded-lg font-medium text-sm whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                  <span>WhatsApp</span>
                </a>
              </div>
            </nav>
          </motion.div>
        )}
      </div>
    </motion.header>
  );
};

export default Header;
